/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { Company } from 'types/entities/Company'

export const normalizeSelectableString = (value: string | number | null) => String(value ?? '')

export const normalizeEmployeeSize = (value: string | number | null) => {
    if (typeof value === 'string' && value.trim() !== '') {
        return value
    }

    return undefined
}

export const trimOrFallback = (value: string | undefined, fallback: string | undefined) => {
    return value?.trim() || fallback
}

export const filterDuplicatesExcludingCurrent = (duplicates: Company[], currentCompanyId?: number) => {
    return duplicates.filter((duplicate) => duplicate.id !== currentCompanyId)
}

export const hasDuplicateCheckInput = (name?: string, registrationNumber?: string, vatNumber?: string) => {
    return Boolean(
        (name && name.length > 2) ||
        (registrationNumber && registrationNumber.length > 2) ||
        (vatNumber && vatNumber.length > 2)
    )
}
